import { deepOrange, grey } from '@material-ui/core/colors/';
import { createMuiTheme, makeStyles } from '@material-ui/core/styles';

export const darkBlue = '#003153'; 

export const orange = darkBlue; 

export const lightOrange = deepOrange.A100;

export const gray = '#808080';
export const lightGray = '#ccc';
export const lightGrayBorder = '#d9d9d9';
export const darkGray = grey[100];
export const mediumGray = '#aaa';

export const darkWhite = '#f9f9f9';

export const mediumGrayBlue = '#8899a0';
export const lightGrayBlue = '#ccdde0';

export const origninalRed = '#ff1744';
export const originalOrange = '#ff4c00';
export const orignalGreen = '#1bb71f';

export const lightGreen = '#00A69C';
export const lightBlue = '#AADBE5';
export const yellow = '#ffc91f';
export const green = lightGreen; '#8CD600' //old color '#1bb71f';
export const darkOrange = '#FF5400'
export const red = originalOrange;'#ff001a' //old color is '#ff1744';

export const orangeThemeLight = createMuiTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    type: 'light',
    primary: deepOrange,
    secondary: deepOrange,
  },
  overrides: {
    MuiExpansionPanel: {
      root: {
        '&:before': {
          display: 'none',
        },
      },
    },
  },
});

export const orangeThemeDark = createMuiTheme({
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    // default is 14
    fontSize: 12,
  },
  palette: {
    type: 'dark',
    primary: {
      main: orange,
    },
    secondary: {
      main: orange,
    },
  },
  overrides: {
    MuiExpansionPanel: {
      root: {
        '&:before': {
          display: 'none',
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: 'white',
        '&$checked': {
          color: '#white',
        },
      },
    },
  },
});

export const whiteThemeDark = createMuiTheme({
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    // default is 14
    fontSize: 12,
  },
  palette: {
    type: 'dark',
    primary: {
      main: '#fff',
    },
    secondary: {
      main: '#fff',
    },
  },
  overrides: {
    MuiExpansionPanel: {
      root: {
        '&:before': {
          display: 'none',
        },
      },
    },
  },
});

export const smallIconSize = { width: '20px', height: '20px' };

export function rootStyle(root: object, props?: object) {
  return makeStyles({ ...{ root: root }, ...props } as any);
}
